import { call, put, takeEvery } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import axios from 'axios';
import API from '../../API';
import Cookies from 'js-cookie';


const apiUrl = API.baseURL + `/social_login/sign_up`;
async function postApi(data) {
    try {
        // const response = await fetch(apiUrl, requestOptions);
        const response = axios.post(apiUrl, data, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* socialSignin(action) {
    try {
        const response = yield call(postApi, action.data);
        if (response.status == 200 || response.status == 201) {
            // Save confirmation_token to cookies if it exists in the response
            if (response.data && response.data.data && response.data.data.confirmation_token) {
                Cookies.set('confirmation_token', response.data.data.confirmation_token);
                console.log('Social Signup API - Saved confirmation_token to cookies:', response.data.data.confirmation_token);
            }
            
            yield put({ type: 'POST_SOCIAL_SIGNUP_SUCCESS', registerPersonal: response });
            yield put({ type: 'STORE_ACTIVE_REG_STEP_SUCCESS', activeStep: 2 });
            yield put({ type: 'POST_REGISTER_PERSONAL_SUCCESS', registerPersonal: response });
            // localStorage.setItem("providerID",action.data.data.provider.provider_id);
            // toastr.success('Register Personal Success', 'You are successfully completed the 1st step');
        } else {
            // response.errors.length != 0 && toastr.error('Register business  failed', response.errors[0]);
        }
        // history.push('/');
    } catch (e) {
        // toastr.error('Failed', "Register personal  failed");
        yield put({ type: 'POST_SOCIAL_SIGNUP_FAILED', message: e.message });
    }
}

function* socialSignupSaga() {
    yield takeEvery('POST_SOCIAL_SIGNUP_REQUESTED', socialSignin);
}

export default socialSignupSaga;